import sliceCreator from '../../index.jsx';
import {CREATE_ZONE} from '../../../constants/index.jsx';
const _createZoneAction = sliceCreator('CREATE_ZONE', CREATE_ZONE, 'post');

const { asyncAction: createZoneAction, reducer, clearData: clearCreateZoneAction } = _createZoneAction;

export default reducer;

export {
    createZoneAction,
    clearCreateZoneAction
}